import { EstadoPagare2, EstadoPagare } from './../../../../models/pagare.model';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ParametrosService } from 'app/services/parametros.service';
import { take } from 'rxjs';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { FuseAlertType } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';
import { Notificacion } from 'app/models/parametro.model';

export interface IUsuarios {
    estado: string;
}

interface Select {
    value: string;
    viewValue: string;
}

const USUARIOS_DATA: IUsuarios[] = [
    {
        estado: 'Pre-emisión',
    },
    {
        estado: 'Cancelado',
    },
    {
        estado: 'Emitido',
    },
    {
        estado: 'Anulado',
    },
    {
        estado: 'Enviado a Notaría',
    },
    {
        estado: 'Notariado',
    },
    {
        estado: 'Judicializado',
    },
    {
        estado: 'Devuelto al cliente',
    },
    {
        estado: 'Con acuerdo',
    },
];

@Component({
    selector: 'formulas',
    templateUrl: './formulas.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class FormulasComponent implements OnInit {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    public customPatterns = { '0': { pattern: new RegExp('^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]{1,50}$') } };

    date = new FormControl(new Date());
    constructor(private route: Router, private _ParametrosService: ParametrosService) {}

    montoMinimoPagare: number = null;
    alertaFolios: number = null;
    tasaMaxima: number = null;

    guardandoCambiosPagare: boolean = false;
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    showAlert: boolean = false;
    goback(): void {
        this.route.navigateByUrl('home/sistema');
    }

    selected = '1';

    areas: Select[] = [
        { value: '1', viewValue: 'Seleccione Rol Area/Evento' },
        { value: '2', viewValue: 'Cobranzas' },
        { value: '3', viewValue: 'Cobranzas' },
        { value: '4', viewValue: 'Cobranzas' },
    ];

    // infoPagareFormulario24 = {
    //     RUT: { ID_RECURSO: null, NOMBRE_RECURSO: 'RUT', VALOR_RECURSO: null },
    //     MONTO_MINIMO_EMISION_PAGARE: { ID_RECURSO: null, NOMBRE_RECURSO: 'MONTO_MINIMO_EMISION_PAGARE', VALOR_RECURSO: null },
    //     ALERTA_SOLICITUD_FOLIO: { ID_RECURSO: null, NOMBRE_RECURSO: 'ALERTA_SOLICITUD_FOLIO', VALOR_RECURSO: null },
    //     TASA_MAXIMA: { ID_RECURSO: null, NOMBRE_RECURSO: 'TASA_MAXIMA', VALOR_RECURSO: null },
    //     RAZON_SOCIAL: { ID_RECURSO: null, NOMBRE_RECURSO: 'RAZON_SOCIAL', VALOR_RECURSO: null },
    //     REPRESENTANTE_LEGAL: { ID_RECURSO: null, NOMBRE_RECURSO: 'REPRESENTANTE_LEGAL', VALOR_RECURSO: null },
    //     FECHA_ESCRITURA_PUBLICA: { ID_RECURSO: null, NOMBRE_RECURSO: 'FECHA_ESCRITURA_PUBLICA', VALOR_RECURSO: null },
    //     FONO: { ID_RECURSO: null, NOMBRE_RECURSO: 'FONO', VALOR_RECURSO: null },
    //     DIRECCION: { ID_RECURSO: null, NOMBRE_RECURSO: 'DIRECCION', VALOR_RECURSO: null },
    //     COMUNA: { ID_RECURSO: null, NOMBRE_RECURSO: 'COMUNA', VALOR_RECURSO: null },
    //     CIUDAD: { ID_RECURSO: null, NOMBRE_RECURSO: 'CIUDAD', VALOR_RECURSO: null },
    // };
    infoPagareFormulario24 = null;

    displayedColumns: string[] = ['estado', 'nuevo'];

    dataSource: MatTableDataSource<any>;

    selection = new SelectionModel<any>(true, []);
    estadosPagare: EstadoPagare2[] = [];
    salidaPagare: EstadoPagare[] = [];
    salidaNotificaciones: Notificacion[] = [];
    mailAlertaFolio: string = '';
    mailJudicial: string = '';
    ngOnInit() {
        /* Preparacion de datos, lo normal es que el dataSource respete la estructura de una interfaz/modelo */

        let preData = USUARIOS_DATA.map((m) => ({ ...m }));

        /* Configuracion basica */

        this.dataSource = new MatTableDataSource<any>(preData);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.selection = new SelectionModel<any>(true, []);

        this.getParametrosPagareFormulario24();
        /* Estados Pagare*/
        this._ParametrosService
            .getEstadosPagare()
            .pipe(take(1))
            .subscribe({
                next: (pagare) => {
                    this.salidaPagare = pagare;
                    this.estadosPagare = pagare.map((elem) => ({
                        ID_ESTADO: elem.ID_ESTADO,
                        NOMBRE_ESTADO: elem.NOMBRE_ESTADO,
                        VALOR: '',
                    }));
                    //console.log(this.estadosPagare);
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {},
            });
        /* Obtener Notificaciones*/
        this._ParametrosService
            .getNotificaciones()
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.salidaNotificaciones = data;
                    this.mailJudicial = data[1].VALOR_RECURSO;
                    this.mailAlertaFolio = data[0].VALOR_RECURSO;
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {},
            });
    }
    /** */

    /**
        Función para eliminar del dataSource los elementos seleccionados.
    */

    ejemploBorrarSeleccionados() {
        console.log('dataSource', this.dataSource.data);
        console.log('Seleccionados', this.selection.selected);
        this.dataSource.data = this.dataSource.data.filter((f) => !this.selection.selected.some((s) => s.id == f.id));
        this.selection = new SelectionModel<any>(true, []);
        this.dataSource._updateChangeSubscription();
        console.log('dataSourceeliminado', this.dataSource.data);
    }
    /**
        Función guardarNotificaciones
    */
    guardarMailNotificaciones() {
        if (this.salidaNotificaciones[0].VALOR_RECURSO == this.mailAlertaFolio && this.salidaNotificaciones[1].VALOR_RECURSO == this.mailJudicial) {
            this.alert = {
                type: 'error',
                message: 'Correo ingresado ya se encuentra registrado',
            };
            this.alertShow();
        } else {
            this.salidaNotificaciones[0].VALOR_RECURSO = this.mailAlertaFolio;
            this.salidaNotificaciones[1].VALOR_RECURSO = this.mailJudicial;
            this._ParametrosService
                .updateMailNotificaciones(this.salidaNotificaciones)
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        this.alert = {
                            type: 'success',
                            message: 'Correos de notificación actualizados exitosamente.',
                        };
                        this.alertShow();
                    },
                    error: (err) => {
                        console.log(err);
                        this.alert = {
                            type: 'error',
                            message: 'Falló la actualización de correos',
                        };
                        this.alertShow();
                    },
                    complete: () => {},
                });
        }
    }
    /**
        Función guardarEstados
    */
    guardarEstados() {
        // console.log('hla', this.estadosPagare);
        let arrayEstados = [];
        let flagError = null;
        let flagVacio = 0;
        //generamos array local con nombres iniciales
        let arrayLocal = [];
        arrayLocal = this.estadosPagare.map((elem) => ({
            NOMBRE_ESTADO: elem.NOMBRE_ESTADO,
        }));
        this.estadosPagare.reduce((acc, item) => {
            let nombreEstado = null;
            //COMPARAMOS NOMBRES INICIALES CON LOS NUEVOS
            if (arrayLocal.some((elem) => elem.NOMBRE_ESTADO == item.VALOR)) {
                this.alert = {
                    type: 'error',
                    message: 'Estado ya existe',
                };
                flagError = 1;
            }
            if (item.VALOR == '') {
                nombreEstado = item.NOMBRE_ESTADO;
            } else {
                nombreEstado = item.VALOR;
                flagVacio = flagVacio + 1;
            }
            let estado = { ID_ESTADO: item.ID_ESTADO, NOMBRE_ESTADO: nombreEstado };
            arrayEstados.push(estado);
            return { acc };
        }, {});
        if (flagVacio == 0) {
            flagError = 1;
            this.alert = {
                type: 'error',
                message: 'No se ha ingresado información para actualizar.',
            };
        }
        if (flagError == 1) {
            this.alertShow();
        } else {
            this._ParametrosService
                .updateEstadosPagare(arrayEstados)
                .pipe(take(1))
                .subscribe({
                    next: (estados) => {
                        this.alert = {
                            type: 'success',
                            message: 'Estados actualizados exitosamente.',
                        };
                        this.alertShow();
                        this.estadosPagare = estados.map((elem) => ({
                            ID_ESTADO: elem.ID_ESTADO,
                            NOMBRE_ESTADO: elem.NOMBRE_ESTADO,
                            VALOR: '',
                        }));
                    },
                    error: (err) => {
                        console.log(err);
                        switch (err.status) {
                            default:
                                this.alert = {
                                    type: 'error',
                                    message: 'No se pudo completar la operación',
                                };
                                break;
                        }
                        this.alertShow();
                    },
                    complete: () => {},
                });
        }
    }
    /**
        Función  para ver detalle
    */
    onTableAction(row: any) {
        // console.log('ver detalles de', row)
    }

    /* Funciones de selección */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    toggleAllRows() {
        this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    /* Carga correcta del sort */
    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }

    getParametrosPagareFormulario24() {
        this._ParametrosService
            .getPagareFormulario24()
            .pipe(take(1))
            .subscribe({
                next: (infoPagareFormulario24) => {
                    console.log(this.infoPagareFormulario24);
                    let dictPaso = {};

                    infoPagareFormulario24.plantillas_pagare_formulario.forEach((element) => {
                        dictPaso[element.NOMBRE_RECURSO] = element;
                    });
                    console.log(dictPaso);
                    this.infoPagareFormulario24 = dictPaso;
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {},
            });
    }
    guardarCambioPagareFormulario24() {
        this.guardandoCambiosPagare = true;
        this.infoPagareFormulario24.TASA_MAXIMA.VALOR_RECURSO = this.infoPagareFormulario24.TASA_MAXIMA.VALOR_RECURSO.replace(',', '.');
        this.infoPagareFormulario24.FECHA_ESCRITURA_PUBLICA.VALOR_RECURSO = new Date(
            this.infoPagareFormulario24.FECHA_ESCRITURA_PUBLICA.VALOR_RECURSO)
            .toISOString().split('T')[0];
        
        let arrayInfoPagareFormulario24 = Object.values(this.infoPagareFormulario24);
        this._ParametrosService
            .postPagareFormulario24(arrayInfoPagareFormulario24)
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this.guardandoCambiosPagare = false;
                    //console.log('ok');
                    this.alert = {
                        type: 'success',
                        message: 'Cambios guardados',
                    };
                    this.alertShow();
                },
                error: (err: any) => {
                    console.log(err);
                    //console.log('notok');
                    switch (err.status) {
                        default:
                            this.alert = {
                                type: 'error',
                                message: 'No se pudo completar la operación',
                            };
                            break;
                    }
                    this.alertShow();
                    this.guardandoCambiosPagare = false;
                },
                complete: () => {},
            });
    }

    alertShow() {
        this.showAlert = true;
        setTimeout(() => {
            this.showAlert = false;
        }, 3000);
    }
}
